module.exports = __webpack_public_path__ + "static/img/about_item01.701d6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_item01.png
// module id = 16Kb
// module chunks = 2